/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import {ObjectUtils} from "../../../Utils/ObjectUtils";

export class JsonValidator extends BaseValidator {
	logic(x, model, data) {
		return ObjectUtils.IsJson(x) || x === null;
	}

	message(model) {
		return "Must be valid JSON.";
	}
}